import { useHits } from 'react-instantsearch';
import { HitFormation } from '../types';
import CardFormation from '@/components/card/CardFormation';

export default function CustomHitsFormations() {
  const { hits } = useHits<HitFormation>({});
  return (
    <>
      <div className="mb-4 grid w-full grid-cols-1 gap-x-4 md:grid-cols-2 lg:mb-4 lg:grid-cols-4">
        {hits.map((hit) => {
          if (hit.type === 'formation') {
            const callToActionUrl = {
              url: `/formations/${hit.id}`,
              slug: '',
              external: false,
              linkText: '',
            };
            const thumb = hit?.image?.includes('htm') ? '' : hit?.thumbnail;
            return (
              <CardFormation
                key={hit.id}
                callToActionUrl={callToActionUrl}
                title={hit.title || ''}
                isoDate={hit.date_published || ''}
                typeCard="formation"
                category={hit.theme || ''}
                mode={hit.mode || ''}
                domain={hit.domain || ''}
                duration_hours={hit.duration_hours || ''}
                reference={hit.reference || ''}
                image={thumb || ''}
              />
            );
          } else if (hit.type === 'session') {
            const callToActionUrl = {
              url: `/formations/${hit.formation_id}`,
              slug: '',
              external: false,
              linkText: '',
            };
            const thumb = hit?.formation_image?.includes('htm') ? '' : hit?.formation_thumbnail;
            return (
              <CardFormation
                key={hit.id}
                callToActionUrl={callToActionUrl}
                title={hit.formation_title || hit.title || ''}
                typeCard="session"
                category={hit.formation_theme || ''}
                mode={hit.formation_mode || ''}
                domain={hit.formation_domain || ''}
                duration_hours={hit.formation_duration_hours || ''}
                date_start={hit.date_start || ''}
                date_end={hit.date_end || ''}
                postal_code={hit.postal_code || ''}
                location={hit?.place || ''}
                subscribe_button={hit.subscribe_button || hit.subscribeBtn || ''}
                reference={hit.reference || ''}
                image={thumb || ''}
                entity={hit.entity || ''}
              />
            );
          }
          return null;
        })}
      </div>
    </>
  );
}
